<template>
  <div class="root" ref="sumoning">
    <div class="title"></div>
      <List v-if="!sumoning.length <=0" v-model="loading" :finished="finished" @onload="getAdminSummoning">
          <SummoningOrderItem  v-for="item of sumoning" :key="item.id" v-bind="item" />
      </List>
      <div v-else class="empty">
          <span>运营还没有发布召集活动哦!</span>
          <button @click="goHome">返回首页</button>
      </div>
      <Suspension v-if="sumoning.length <=0" bottom="36px" desc="首页" img="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/home.svg" @share="goHome"/>
  </div>
</template>

<script>
import List from '../../../../components/list'
import SummoningOrderItem from '../../../../components/SummoningOrderItem'
import { remove, get as getUser } from '../../../../utils/token'
import { get } from '../../../../utils/request'
import { goHomePath } from '../../../../utils/power'
import DDMixis from '../../../../minixs/ddMixis'
export default {
  data () {
    return {
      touchStart: 0,
      safeHeight: 0,
      loading: false,
      finished: false,
      sumoning: [],
      page: 1, // 当前页
      size: 10, // 每页展示的数据
      count: 0 // 总数据
    }
  },
  components: {
    SummoningOrderItem,
    List
  },
  mixins: [DDMixis],
  activated () {
    this.pageInit()
  },
  methods: {
    // 页面初始化
    pageInit () {
      this.page = 1
      this.count = 0
      this.sumoning.length = 0
      this.getAdminSummoning()
      this.addUpRefresh()
    },
    goHome () {
      this.$router.push({
        path: goHomePath()
      })
    },
    scrollLocation () {
      this.$nextTick(() => {
        const scrollTop = getUser('scrollSumoning')
        if (scrollTop) {
          this.$refs.sumoning.scrollTop = scrollTop
          remove('scrollSumoning')
        }
      })
    },
    async getAdminSummoning () {
      const user = getUser('user')
      const { page, size } = this
      try {
        const {
          data: {
            code,
            detail: { count, list }
          }
        } = await get({
          url: `/call/talesList/${user.id}?&topic=1&page=${page}&size=${size}`
        })
        if (code === 200) {
          this.count = count
          // 下拉刷新时
          if (this.downRefresh) {
            this.sumoning = list
          } else {
            this.sumoning = [...this.sumoning, ...list]
          }
          this.loading = false
          const { sumoning, page } = this
          if (count > sumoning.length) {
            this.loading = true
            this.page = page + 1
          } else {
            this.finished = true
          }
          this.loading = false
          this.scrollLocation()
        }
      } catch (error) {
        /* eslint-disable-next-line */
        console.error(error)
      }
    },
    addUpRefresh () {
      const el = this.$refs.sumoning
      const offsetHeight = el.offsetHeight
      el.addEventListener('scroll', () => {
        if (this.loading) {
          return
        }
        const scrollHeight = el.scrollHeight
        const scrollTop = el.scrollTop
        if (offsetHeight + scrollTop >= scrollHeight) {
          const { count, sumoning, page } = this
          if (count > sumoning.length) {
            this.loading = true
            this.page = page + 1
            this.getAdminSummoning()
          }
        }
      })
    },
    addDownRefresh () {
      const el = this.$refs.sumoning
      el.addEventListener('touchstart', e => {
        if (this.downRefresh) {
          e.preventDefault()
          return
        }
        this.touchStart = e.targetTouches[0].clientY
      })
      el.addEventListener('touchmove', e => {
        if (this.downRefresh) {
          e.preventDefault()
          return
        }
        if (el.scrollTop === 0) {
          const touch = e.targetTouches[0]
          const distance = touch.clientY - this.touchStart
          this.distance = distance
          if (distance > 50) {
            this.downRefresh = true
            this.downLabel = '松手刷新数据'
          }
        }
      })
      el.addEventListener('touchend', e => {
        if (this.distance > 50) {
          this.downRefresh = true
          this.downLabel = '正在刷新'
          e.preventDefault()
          this.page = 1
          this.getAdminSummoning()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.root {
  width: calc(100% - 50px);
  box-sizing: border-box;
  z-index: 1;
  height: 100%;
  margin:0 auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  .title{
    text-align: center;
    height:20px;
    line-height: 50px;
    font-size: 20px;
    font-weight: 600;
  }
  .empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  span {
    width: 176px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(136, 136, 136, 1);
    line-height: 26px;
  }
  button {
    width: 132px;
    height: 44px;
    background: rgba(245, 245, 245, 1);
    border-radius: 4px;
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 24px;
    border: none;
    outline: none;
    margin-top: 25px;
  }
}
}

</style>
